<template lang="pug">
table.table.is-striped(v-show='products.length')
	thead
		tr
			td Item
			td Quantity
			td Price
			td Amount
	tbody
		tr(v-for='p in products')
			td
				| {{ p.name }}
				.spacing-ls(v-if="p.options && p.sku == 4002 && (p.options.softCopyArrange == 811 || p.options.softCopyArrange == 2522)")
					| Standard arrangement for placement within a CAD drawing: {{ softCopyArrange[p.options.softCopyArrange] }}
					.spacing-ls(v-if="p.options.softCopyArrange == 2522")
						| Format: {{ p.options.softStandardFormat }}
				.spacing-ls(v-if="p.options && p.sku == 4002 && (p.options.softCopyArrange == 1824 || p.options.softCopyArrange == 2436 || p.options.softCopyArrange == 3042)")
					| Full sheet with easyTitle24.com title block in PDF Format: {{ softCopyArrange[p.options.softCopyArrange] }}

				.spacing-ls(v-if="p.options && p.sku == 5003")
					| Important report pages (Forms CF-1R &amp; MF-1R): {{ hardCopySize[p.options.hardCopySize] }}
			td {{ p.quantity }}
			td ${{ p.price }}
			td ${{ calcProductAmount(p.quantity, p.price) }}
		tr
			td
				b Subtotal:
			td
			td
				b ${{ subtotal }}
		tr
			td
				b Tax:
			td
			td
				b ${{ taxAmount }}
		tr
			td
				b Total:
			td
			td
				b ${{ total }}
</template>
<script>
export default {
	name: 'invoice-detail',
	props: ['products', 'subtotal', 'taxAmount', 'total'],
	data () {
		return {
			hardCopySize: {
				'1824': '18" x 24"', '2436': '24" x 36"', '3042': '30" x 42"'
			},
			softCopyArrange: {
				'811': 'Individual 8&frac12" x 11" pages in JPEG Format',
				'2522': '25&frac12" x 22" block',
				'1824': '18" x 24"',
				'2436': '24" x 36"',
				'3042': '30" x 42"'
			}
		}
	},
	methods: {
		calcProductAmount (quantity, price) {
			return (quantity * price).toFixed(2)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/common/components/invoice-detail.vue